import React, { useContext, useRef, useState } from "react";
import { axiosUrl } from "../../api/axios";
import { UserContext } from "../../App";
import CryptoWidget from "../../components/Dashboard/CryptoWidget";
import DashboardLayout from "../../layouts/DashboardLayout";

const Account = () => {
  const { userData } = useContext(UserContext);
  const [inputValue, setInputValue] = useState("");
  const [cryptoType, setCryptoType] = useState("");
  const errRef = useRef();
  const user = userData.user;

  const handleChange = (e) => {
    e.preventDefault();
    setInputValue(e.target.value);
  };

  const handleChangeSelect = (e) => {
    e.preventDefault();
    setCryptoType(e.target.value);
  };

  // const quickWithdrawal = (e) => {
  //   e.preventDefault();

  //   if (inputValue > userData.user.profit) {
  //     alert("Amount not available for withdrawal");
  //     errRef.current.focus();
  //     setInputValue("");
  //     return;
  //   } else if (inputValue <= 0) {
  //     alert("Amount not available for withdrawal");
  //     errRef.current.focus();
  //     setInputValue("");
  //     return;
  //   } else if (!cryptoType) {
  //     alert("Please select a wallet");
  //     return;
  //   }

  //   const newTransaction = {
  //     userId: `${userData.user.id}`,
  //     user: `${userData.user.firstName} ${userData.user.lastName}`,
  //     type: "Withdrawal",
  //     amount: inputValue,
  //     mode: cryptoType,
  //     status: false,
  //   };

  //   axiosUrl.post("/transactions", newTransaction);

  //   alert("withdrawal request sent");
  //   window.location.href = "/dashboard";
  // };

   return (
    <DashboardLayout>
      <div className="account">
        <div className="inner">
          <div className="balance-wrapper">
            <div className="balance">
              <div className="first-box box box-shadow "></div>
              <div className="second-box box box-shadow "></div>
              <div className="third-box box box-shadow ">
                <div className="main-box">
                  <small className="text-light fw-bold">Balance</small>
                  <h6>${userData.user.balance}</h6>
                  <small>
                    +3% <i className="fas fa-arrow-up"></i>
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="investments">
            <div className="investment-boxes">
              <div className="first-box">
                <div className="title-text">
                  <h6>Investment</h6>
                </div>
                <div className="invested investment box-shadow">
                  <p>Invested</p>

                  <div className="amount">
                    <i className="fas fa-arrow-up"></i>
                    <p>${userData.user.totalDeposits}</p>
                    <small>
                      +3% <i className="fas fa-arrow-up"></i>
                    </small>
                  </div>
                </div>
              </div>
              <div className="profit investment box-shadow">
                <p>Profit</p>

                <div className="amount">
                  <i className="fas fa-arrow-up"></i>
                  <p>${user.profit}</p>
                  <small>
                    +3% <i className="fas fa-arrow-up"></i>
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="quick-withdrawal">
            <div className="title-text">
              <h6>Quick Withdrawal</h6>
            </div>
            <form>
              <select
                name="select wallet"
                id=""
                placeholder="Select a Wallet"
                value={cryptoType}
                onChange={handleChangeSelect}
              >
                <option value="">Choose Wallet</option>
                <option value="Bitcoin">Bitcoin</option>
                <option value="Ethereum">Ethereum</option>
                <option value="Dogecoin">Dogecoin</option>
                <option value="USDT">USDT</option>
              </select>
              <input
                name="withdraw-amount-input"
                type="number"
                placeholder="Enter Amount"
                value={inputValue}
                onChange={handleChange}
                required
                ref={errRef}
              />
              <button>
                <i className="fas fa-credit-card"></i> Withdraw
              </button>
            </form>
          </div>

          <div className="portfolio todays-earning box-shadow">
            <p>Total Deposits</p>

            <div className="amount">
              <p>${userData.user.totalDeposits}</p>
              {/* <p>${userData.user.totalDeposits}</p> */}
              <small>
                +0% <i className="fas fa-arrow-up"></i>
              </small>
            </div>
          </div>

          <div className="portfolio total-earning box-shadow">
            <p>Total Earnings</p>

            <div className="amount">
              <p>${userData.user.profit}</p>
              {/* <p>${userData.user.totalEarnings}</p> */}
              <small>
                +0% <i className="fas fa-arrow-up"></i>
              </small>
            </div>
          </div>

          <div className="portfolio total-withdrawal box-shadow">
            <p>Total Withdrawal</p>

            <div className="amount">
              <p>${userData.user.totalWithdrawal}</p>
              <small>
                +0% <i className="fas fa-arrow-down"></i>
              </small>
            </div>
          </div>

          <CryptoWidget
            symbol="COINBASE:BTCUSD"
            trendLineColor="rgba(0, 168, 220, 1)"
            underLineColor="rgba(0, 0, 0, 0.3)"
            underLineBottomColor="rgba(41, 98, 255, 0)"
          />
          <CryptoWidget
            symbol="BINANCE:DOGEUSD"
            trendLineColor="rgba(191, 144, 0, 1)"
            underLineColor="rgba(166, 77, 121, 0.3)"
            underLineBottomColor="rgba(41, 98, 255, 0)"
          />
          <CryptoWidget
            symbol="BINANCE:ETHUSD"
            trendLineColo="rgba(111, 168, 220, 1)"
            underLineColor="rgba(153, 0, 0, 0.3)"
            underLineBottomColor="rgba(41, 98, 255, 0)"
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Account;
